export class InDesignArticle {
    public __classname__: string = 'InDesignArticle';
    
    public Id : string | null = null;
	public Name : string | null = null;
	public SplineIDs : string[] | null = null;

    constructor(
        Id : string | null = null, 
        Name : string | null = null, 
        SplineIDs : string[] | null = null
    ) {
        this.Id = Id;
        this.Name = Name;
        this.SplineIDs = SplineIDs;
    }
}
